import { observer } from "mobx-react";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import ApiKeyField from "../fields/api-key-field/api-key-field";
import ApiKeyCredentialsStore from "../../../../stores/credentials/shipping/api-key-credentials-store";

interface IIntegrationProps {
    credentialsStore: ApiKeyCredentialsStore;
    vGroup: IValidationGroup;
    apiKeyLabel?: string;
    apiKeyNote?: string;
}

const ApiKeyCredentials: React.FC<IIntegrationProps> = observer(
    ({ credentialsStore, vGroup, apiKeyLabel, apiKeyNote }) => {
        return (
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label={apiKeyLabel}
                note={apiKeyNote}
            />
        )
    });

export default ApiKeyCredentials;
